import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Collapse, List } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { WAVE_STYLE } from '../../../Preview/PreviewDisplayConstants';
import WaveLayerFillColorListItem from '../inputs/WaveLayerFillColorListItem';
import WaveLayerLineColorListItem from '../inputs/WaveLayerLineColorListItem';
import WaveLayerLineWidthListItem from '../inputs/WaveLayerLineWidthListItem';
import WaveLayerCutoutListItem from '../inputs/custom/WaveLayerCutoutListItem';
import WaveLayerCustomListItem from '../inputs/custom/WaveLayerCustomListItem';

const styles = theme => ({
    collapse: {
        cursor: 'default',
        backgroundColor: theme.palette.background.paperDark
    }
});

const AdvancedItems = memo(({ index, waveLayerLineWidth }) => (
    <>
        <WaveLayerLineWidthListItem index={index} />
        {/* Outline Color sits directly below Outline Width and only when there is an outline. */}
        <Collapse in={waveLayerLineWidth > 0} unmountOnExit>
            <WaveLayerLineColorListItem index={index} advanced />
        </Collapse>
        <WaveLayerCutoutListItem index={index} />
        <WaveLayerCustomListItem index={index} />
    </>
));

const WaveLayerContent = memo(({ open, classes, index, advanced, waveLayerLineWidth, effectiveWaveStyle }) => (
    <Collapse in={open} className={classes.collapse}>
        <List dense disablePadding>
            {/* Line has no fill, so its Layer Color control collapses away. */}
            <Collapse in={effectiveWaveStyle !== WAVE_STYLE.LINE} unmountOnExit>
                <WaveLayerFillColorListItem index={index} advanced={advanced} />
            </Collapse>

            {!advanced && (
                <Collapse in={waveLayerLineWidth > 0} unmountOnExit>
                    <WaveLayerLineColorListItem index={index} advanced={advanced} />
                </Collapse>
            )}

            {advanced && <AdvancedItems index={index} waveLayerLineWidth={waveLayerLineWidth} />}
        </List>
    </Collapse>
));

const mapStateToProps = (state, { index }) => {
    const visualizer = state.createPreview.present.videoSettings.visualizer;
    const layer = visualizer.waveCircles[index];
    const customEnabled = layer.customOptions && layer.customOptions.enabled;
    const effectiveWaveStyle = customEnabled ? layer.customOptions.waveStyle : visualizer.waveStyle;
    return { effectiveWaveStyle };
};

export default connect(mapStateToProps)(withStyles(WaveLayerContent, styles));
